/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppEmbeddedSignupDisconnectWhatsApp } from '../../axios/whatsAppEmbeddedSignupDisconnectWhatsApp'
import type {
	WhatsAppEmbeddedSignupDisconnectWhatsAppError,
	WhatsAppEmbeddedSignupDisconnectWhatsAppPathParams,
	WhatsAppEmbeddedSignupDisconnectWhatsAppResponse,
} from '../../types/WhatsAppEmbeddedSignupDisconnectWhatsApp'

export const whatsAppEmbeddedSignupDisconnectWhatsAppMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-account/disconnect' }] as const

export type WhatsAppEmbeddedSignupDisconnectWhatsAppMutationKey = ReturnType<
	typeof whatsAppEmbeddedSignupDisconnectWhatsAppMutationKey
>

export type WhatsAppEmbeddedSignupDisconnectWhatsAppVariables = {
	organisationId: WhatsAppEmbeddedSignupDisconnectWhatsAppPathParams['organisationId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::disconnectWhatsApp */
export function useWhatsAppEmbeddedSignupDisconnectWhatsApp<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppEmbeddedSignupDisconnectWhatsAppResponse,
		AxiosError<WhatsAppEmbeddedSignupDisconnectWhatsAppError>,
		WhatsAppEmbeddedSignupDisconnectWhatsAppVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppEmbeddedSignupDisconnectWhatsAppMutationKey(),
		mutationFn: ({ organisationId }: WhatsAppEmbeddedSignupDisconnectWhatsAppVariables) =>
			whatsAppEmbeddedSignupDisconnectWhatsApp(organisationId, config).then(res => res.data),
		...options,
	})
}
